import { render, staticRenderFns } from "./common-city-town-taiwan.vue?vue&type=template&id=44ea208a&scoped=true"
import script from "./common-city-town-taiwan.vue?vue&type=script&lang=js"
export * from "./common-city-town-taiwan.vue?vue&type=script&lang=js"
import style0 from "./common-city-town-taiwan.vue?vue&type=style&index=0&id=44ea208a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea208a",
  null
  
)

export default component.exports